import { bindActionCreators, useSelector } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Board from '../components/Board';

const makeMapStateToProps = () => {
  const selectCardNamesByIds = selectors.makeSelectCardNamesByIds(); // ─── C2 ───

  return (state) => {
    const { cardId, boardId } = selectors.selectPath(state);
    const listIds = selectors.selectListIdsForCurrentBoard(state);
    const lists = selectors.selectListsForCurrentBoard(state);
    const layout = selectors.selectHierarchyLayoutForCurrentBoard(state);
    console.log('Selector test du CurrentUserRoleAssignments');
    console.log(selectors.selectCurrentUserRoleAssignments(state));
    console.log(selectors.selectCurrentUserRoles(state));
    console.log(selectors.selectHasPermission(state, 'Board', boardId, 'board_edit'));
    // console.log(selectors.selectPermissionsForResource(state, 'Board', boardId));
    // const currentProject = selectors.selectCurrentProject(state);
    const isCurrentUserManager = selectors.selectCanManageCurrentProject(state);

    const isCurrentUserOwner = selectors.selectIsOwnerBoard(state);
    // selectors.selectHasPermission(state, 'Project', currentProject.id, 'board_admin'); // On vérifie qu'on a board_admin dans le role associé au projet
    console.log('On est Owner');
    console.log(isCurrentUserOwner);

    // ─── C2 : collecte de TOUS les parentIds (tous niveaux) ───
    const parentIdsSet = new Set();
    if (layout && layout.groupsByLevel) {
      Object.values(layout.groupsByLevel).forEach((levelCells) => {
        Object.values(levelCells).forEach((cell) => {
          Object.keys(cell.parentGroups).forEach((parentId) => {
            parentIdsSet.add(parentId);
          });
        });
      });
    }
    const parentNames = selectCardNamesByIds(state, Array.from(parentIdsSet));

    return {
      boardId,
      listIds,
      lists,
      layout,
      parentNames, // ─── C2 ───
      isCardModalOpened: !!cardId,
      canEdit: isCurrentUserOwner || isCurrentUserManager,
    };
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onListCreate: entryActions.createListInCurrentBoard,
      onListMove: entryActions.moveList,
      onCardMove: entryActions.moveCard,
      onCardTransfer: entryActions.transferCard,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(Board);
